import React from "react";

export const CoachRources = () => {
  return <div>CoachRources</div>;
};
